// extracted by mini-css-extract-plugin
module.exports = {"menu_container":"Menu_menu_container__1SUb_","submit":"Menu_submit__3ZSi2","order_num_panel":"Menu_order_num_panel__3k3yb","order_num":"Menu_order_num__1Yag5"};